import { render } from "./NavBarItemLabel.vue?vue&type=template&id=5cbb566a"
import script from "./NavBarItemLabel.vue?vue&type=script&lang=js"
export * from "./NavBarItemLabel.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__